






































import { computed, defineComponent, ComponentInternalInstance, getCurrentInstance, ref } from '@vue/composition-api';
import smh, { SMH } from '@/renderer/scripts/smh';
import tips, { MsgError } from '@/renderer/scripts/utils/tips';
import ipc from '@/renderer/scripts/utils/ipc';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import { IS_BROWSER, IS_PRIVATE } from '@/common/constant/platform';
import { CONSTANT_URL } from '@/renderer/scripts/http';

export default defineComponent({
  setup(props, context) {
    const currComponent: ComponentInternalInstance = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const store = vm.$store;
    const guideFinishedShow = computed(() => {
      const { noviceGuidance } = store.getters;
      return noviceGuidance.baseGuide?.done && !noviceGuidance.guideFinishedShow;
    });
    const downloadUrl = computed(() => {
      return CONSTANT_URL.officialWebsiteDowloadUrl;
    });
    // TCL-Android电视平板屏蔽调下载端的按钮
    const showDownloadButton = computed(() => IS_BROWSER && !IS_PRIVATE && !store.getters.isTclApp);
    const methods = {
      async submit(type: string) {
        const { userBaseInfo } = store.getters;
        let guideName = '';
        switch (userBaseInfo.role) {
          case 'user':
            guideName = 'staff_new_guide_success';
            break;
          case 'admin':
            guideName = 'boss_new_guide_success';
            break;
          case 'superAdmin':
            guideName = 'manager_new_guide_success';
            break;
          default:
            break;
        }
        if (type === 'download') {
          reporter.report(guideName, {
            success_count_type: 'mission_finish_download',
          });
          dispatchRouter(downloadUrl.value);
        } else if (type === 'later') {
          reporter.report(guideName, {
            success_count_type: 'mission_finish_later',
          });
          ipc.emit(ipc.RENDERER_EVENTS_MAP.SHOW_DOWNLOAD_TIPS);
        }
        try {
          const opt = {
            ...store.getters.noviceGuidance,
          };
          opt.guideFinishedShow = true;
          store.commit('setNoviceGuidance', opt);
          await smh.userAPI.createNoviceGuidance(opt);
        } catch (error) {
          tips.error(error as MsgError);
        }
      },
    };
    return {
      showDownloadButton,
      downloadUrl,
      guideFinishedShow,
      ...methods,
    };
  },
});
